import React from 'react'

import EditPackageForm from '../../modules/Package/components/EditPackageForm'
export default function EditPackagePage() {
  return <EditPackageForm />
}
